/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import debounce from "lodash.debounce";

export type DebounceSettings = NonNullable<Parameters<typeof debounce>[2]>;
const DEFAULT_TIMEOUT_MS = 300;

// https://lodash.com/docs/4.17.15#debounce
function useDebouncedCallback<T extends (...args: any) => any>(
  func: T,
  deps: unknown[],
  wait: number | boolean, // true => 300ms, false => no debounce
  settings?: DebounceSettings, // defaults to leading=false, trailing=true, maxWait=undefined
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFunction = React.useCallback(
    wait === false ? func : debounce(func, wait === true ? DEFAULT_TIMEOUT_MS : wait, settings),
    deps,
  );

  React.useLayoutEffect(
    () => () => {
      if ("cancel" in debouncedFunction) debouncedFunction.cancel();
    },
    [debouncedFunction],
  );

  return debouncedFunction;
}

export default useDebouncedCallback;
